import React from 'react';
import styles from "./style.module.scss";
import Switch from '@material-ui/core/Switch';
import { TimeEdge } from '../../mobx-store/storeInterfaces/customerServiceStoreInterface';
import { translate } from '../../helperFunctions/translation';

interface IProps {
    day: string;
    isOpen?: boolean;
    isValid: boolean;
    onToggle: (index: number) => void;
    index: number;
    onChangeTime: (edge: TimeEdge, val: string) => void;
    startTime?: string | null;
    endTime?: string | null;
}

const CustomerServiceWorkingDay = (props: IProps) => {
    
    return (
        <div className={styles.body}>
            <span className={styles.day}>{props.day}:</span>
            <Switch
                checked={props.isOpen}
                onChange={() => props.onToggle(props.index)}
                color="primary"
            />
            <span className={styles.isOpen}>{props.isOpen? translate('open', {}) : translate('closed', {})}</span>
            {props.isOpen && 
            <div className={styles.timeContainer}>
                <input 
                    className={styles.time} 
                    type="time" 
                    value={props.startTime || ''}
                    onChange={(event) => props.onChangeTime(TimeEdge.START_TIME, event.target.value)}
                />
                <span className={styles.dash}>-</span>
                <input 
                    className={styles.time} 
                    value={props.endTime || ''}
                    type="time" 
                    onChange={(event) => props.onChangeTime(TimeEdge.END_TIME, event.target.value)}
                />
            </div>}
            {!props.isValid && <span className={styles.invalid}>{translate('invalidValue', {})}</span>}
        </div>
    )
}

export default CustomerServiceWorkingDay;